// extracted by mini-css-extract-plugin
export var inputContainer = "_s5-0";